import { createReducer, createActions } from "reduxsauce";
import { produce } from "immer";

const INITIAL_STATE = {
    sidebarOpen: true,
};

const { Types, Creators } = createActions({
    setSidebarOpen: ["payload"],
    toggleSidebar: null,
    closeSidebar: null,
    openSidebar: null,
});

export const ActionTypes = Types;
export const Actions = Creators;

export const reducer = createReducer(INITIAL_STATE, {
    [Types.SET_SIDEBAR_OPEN]: produce((draft, { payload }) => {
        draft.sidebarOpen = payload;
    }),
    [Types.TOGGLE_SIDEBAR]: produce((draft) => {
        draft.sidebarOpen = !draft.sidebarOpen;
    }),
    [Types.CLOSE_SIDEBAR]: produce((draft) => {
        draft.sidebarOpen = false;
    }),
    [Types.OPEN_SIDEBAR]: produce((draft) => {
        draft.sidebarOpen = true;
    }),
});


